/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Nbstatechange2Inputs */



/**
* | output |
* | --- |
* | "Number of state changes" |
*
* @param {Ahu_History_Key_Nbstatechange2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_nbstatechange2 = /** @type {((inputs?: Ahu_History_Key_Nbstatechange2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Nbstatechange2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Number of state changes")
	return /** @type {LocalizedString} */ ("Nombre de changements d'état")
});
export { ahu_history_key_nbstatechange2 as "ahu_history_key_nbStateChange" }